import { Component, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { BnLoadingService, MessageChannelService, messageLevel } from "@bndes/bndes-ux4/bndes-angular-utils";
import { BnAlertsService } from "@bndes/bndes-ux4/bn-alerts";
import { BnConfirmDirective } from "@bndes/bndes-ux4/bn-confirm";
import { BnUsuarioService } from "@bndes/bndes-ux4/bn-usuario";
import moment from "moment";
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ROLE_AGENTE_CONSULTA } from 'src/app/constantes/permissao.constants';
import { Arquivo, LabelTipoConteudo, TipoConteudo as TipoConteudo } from 'src/app/model/arquivo.model';
import Utils from 'src/app/shared/fgi-utils';
import { PermissaoService } from 'src/app/shared/permissao.service';
import { ProtocoloArquivoService } from 'src/app/shared/services/protocolo-arquivo.service';
import { RemoverAlertasService } from 'src/app/shared/services/remover-alertas.service';
import {
  loteAmortizacoesExemplo,
  loteLiberacoesExemplo,
  loteOperacoesExemplo,
  OperacaoCreditoLivre,
  loteOperacoesExemploFGEnergia,
  loteOperacoesExemploFGT,
  loteOperacoesExemploFGSEBRAE, loteOperacoesExemploPEAC, loteOperacoesExemploFGTEcgTerceiros
} from '../../../model/operacao-credito-livre.model';
import { FileUtilsService } from '../../../shared/file-utils.service';
import { OcorrenciaValidacaoVO } from '../../../shared/ocorrencia-validacao.vo';
import { OperacaoCreditoLivreService } from './operacao-credito-livre.service';
import { ModalidadeService } from 'src/app/shared/services/modalidade.service';
import {ModalidadeGarantia} from '../../../model/modalidade_garantia.model';


@Component({
    selector: 'app-operacao-lote',
    templateUrl: './operacao-lote.component.html',
    styleUrls: ['./operacao-lote.component.scss'],
    standalone: false
})
export class OperacaoLoteComponent implements OnInit {

  @ViewChild(BnConfirmDirective, {static: false}) bnConfirm: BnConfirmDirective;

  loteOperacoesForm: UntypedFormGroup;

  arquivo: Arquivo;
  labelTipoConteudo: string;
  filecontentTemplate = '';

  private modalidadeGarantia: string; // PEAC ou FGE

  private nomeModalidade: string; // FGI PEAC, etc.

  private enviado: boolean;

  private ocorrencias: OcorrenciaValidacaoVO[] = [];

  private operacoes: OperacaoCreditoLivre[] = [];

  private cnpjUsuario: string;

  private isAgente: boolean;

  private modalidade: ModalidadeGarantia;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private service: OperacaoCreditoLivreService,
    private protocoloService: ProtocoloArquivoService,
    private router: Router,
    private bnAlertsService: BnAlertsService,
    private fileUtils: FileUtilsService,
    private messageService: MessageChannelService,
    private bnUsuarioService: BnUsuarioService,
    private permissaoService: PermissaoService,
    private removerAlertasService: RemoverAlertasService,
    private loadingService: BnLoadingService,
    private modalidadeService: ModalidadeService) {
  }

  ngOnInit() {
    this.createReactiveForm();

    this.bnUsuarioService.usuario$.subscribe(usuario => {
      this.cnpjUsuario = usuario.cnpj;
    });

    this.permissaoService.getPermissoesUsuarioAutenticado().subscribe((resp: any) => {
      this.isAgente = resp && resp[ROLE_AGENTE_CONSULTA];
    });

    this.modalidadeService.modalidade$.subscribe((mod) =>{
      this.modalidadeGarantia = mod;
      for (let modalidade of this.modalidadeService.getModalidades()) {
        if (modalidade.sigla == mod) {
          console.log(modalidade);
          this.modalidade = modalidade;
          this.nomeModalidade = modalidade.nome;
          console.log(this.modalidade);
        }
      }
  })

  }

   createReactiveForm() {
    this.loteOperacoesForm = this.formBuilder.group({
      arquivo: ['', Validators.required],
      opcaoEnvio: ['', Validators.required],
      checkCiencia: ['', [Validators.required, Validators.pattern('true')]]
    });
  }

  baixarExemploContratacao() {

    console.log(this.modalidadeGarantia);
    let conteudoArquivoExemplo!: string;

    switch (this.modalidadeGarantia){
      case 'FGE':
        conteudoArquivoExemplo = loteOperacoesExemploFGEnergia
          .replace("##MODALIDADE_GARANTIA##", this.modalidadeGarantia)
          .replace("\"##COD_VALIDACAO_PROJETO##\"", "\"32950450-f19b-4d94-abef-9b90a05f4bb3\"");
        break;

      case 'FGT':
        if(this.modalidade.utilizaPagamentoDeEcgPorTerceiros){
          conteudoArquivoExemplo = loteOperacoesExemploFGTEcgTerceiros
            .replace("##MODALIDADE_GARANTIA##", this.modalidadeGarantia);
        }else{
          conteudoArquivoExemplo = loteOperacoesExemploFGT
            .replace("##MODALIDADE_GARANTIA##", this.modalidadeGarantia);
        }

        break;

      case 'FGBS':
        conteudoArquivoExemplo = loteOperacoesExemploFGSEBRAE
          .replace("##MODALIDADE_GARANTIA##", this.modalidadeGarantia);
        break;

      case 'PEAC':
        if(this.modalidade.utilizaPagamentoDeEcgPorTerceiros) {
          conteudoArquivoExemplo = loteOperacoesExemploPEAC
            .replace("##MODALIDADE_GARANTIA##", this.modalidadeGarantia);
        }else{
          conteudoArquivoExemplo = loteOperacoesExemplo
            .replace("##MODALIDADE_GARANTIA##", this.modalidadeGarantia);
        }
        break;

      default:
        conteudoArquivoExemplo = loteOperacoesExemplo
          .replace("##MODALIDADE_GARANTIA##", this.modalidadeGarantia);
        break;
    }

    this.fileUtils.exportarArquivo('exemplo-importacao-operacoes.json',
         this.trocaAgenteLogado(conteudoArquivoExemplo), FileUtilsService.APPLICATION_JSON);
  }

  baixarExemploLiberacao() {
    this.fileUtils.exportarArquivo('exemplo-importacao-liberacoes.json',
      loteLiberacoesExemplo, FileUtilsService.APPLICATION_JSON);
  }

  baixarExemploAmortizacao() {
    this.fileUtils.exportarArquivo('exemplo-importacao-amortizacoes-antecipadas.json',
      this.trocaAgenteLogadoAmortizacoes(loteAmortizacoesExemplo), FileUtilsService.APPLICATION_JSON);
  }

  private trocaAgenteLogado(exemploStr): string {
    if (!this.isAgente) {
      return exemploStr;
    }
    const exemplo = JSON.parse(exemploStr);
    for (const operacao of exemplo.operacoes) {
      operacao.cnpjAgenteFinanceiro = this.cnpjUsuario;
    }
    return JSON.stringify(exemplo, null, 2);
  }

  private trocaAgenteLogadoAmortizacoes(exemploStr): string {
      if (!this.isAgente) {
          return exemploStr;
      }

      const exemplo = JSON.parse(exemploStr);
      exemplo.cnpjAgenteFinanceiro = this.cnpjUsuario;
      return JSON.stringify(exemplo, null, 2);
  }

  onFileChange(event) {
    let marcador = new MarcadorTempo("onFileChange");
    this.operacoes = [];
    this.ocorrencias = [];
    this.removerAlertasService.removerTodos();

    this.loteOperacoesForm.markAsDirty();
    const reader = new FileReader();

    if (event.target.files && event.target.files.length) {
      const file = event.target.files[0];

      if (!this.suportaTamArquivo(file.size)) {
        console.log(`Arquivo muito grande ${file.size} bytes`);
        // A mensagem abaixo não aparece se for chamada diretamente aqui
        // Acredito (jmaur) que é por esta em tratamento de evento
        // Colocá-la em um processamento assíncrono (como o setTimeout()) resolve a questão
        setTimeout(() => {
          this.limpar();
          this.bnAlertsService.alertaErro('Erro', `O arquivo ${file.name} é muito grande. Divida em lotes menores e envie um arquivo por vez.`);
        }, 0);
        return;
      }
      marcador.marcaTempo("inicio");

      reader.readAsText(file, "UTF-8");
      reader.onload = () => {
        marcador.marcaTempo("readAsText");

        let conteudoArquivo: string = '';
        if (typeof reader.result === 'string') {
          conteudoArquivo = reader.result;
        } else {
          conteudoArquivo = this.fileUtils.lerConteudo(reader);
        }
        marcador.marcaTempo("lerConteudo");

        // evitar erros com estas aspas estranhas
        conteudoArquivo = conteudoArquivo.replace('“', '"').replace('”', '"');
        marcador.marcaTempo("replace");

        const lote = this.validarArquivo(file.name, file.type, conteudoArquivo);
        marcador.marcaTempo("validarArquivo");
        if (!lote) {
                    return;
        }


        this.arquivo = new Arquivo();
        this.arquivo.filename = file.name;
        this.arquivo.filetype = file.type;
        this.arquivo.value = conteudoArquivo;
        this.arquivo.tipoConteudo = lote.tipoConteudo;
        this.labelTipoConteudo = LabelTipoConteudo.get(this.arquivo.tipoConteudo);

        this.loteOperacoesForm.updateValueAndValidity();
        marcador.marcaTempo("updateValueAndValidity");
      };
    }
  }

  onSubmit() {

    if (!this.arquivo.value) {
      this.bnAlertsService.alertaErro('Erro', 'O arquivo não possui conteúdo.');
      return;
    }

    this.loteOperacoesForm.disable();
    this.enviado = true;
    this.enviarOperacoes();
  }

  enviarOperacoes() {
    this.loadingService.bloqueiaTela();

    this.operacoes = [];
    this.ocorrencias = [];

    let marcador = new MarcadorTempo("enviarOperacoes");

    const msgService = this.messageService;
    const loteOperacoes = JSON.parse(this.arquivo.value);
    marcador.marcaTempo("parse");

    let totalItens = 0;

    // preenche a data de envio

    if (this.arquivo.tipoConteudo === TipoConteudo.OPERACOES) {
      loteOperacoes.operacoes.forEach(ope => {
        ope.dataEnvio = new Date();
        ope.dataReferenciaProtocolo = ope.dataEnvio;
      });
      this.operacoes = loteOperacoes.operacoes;
      totalItens = this.operacoes.length;
    } else if (this.arquivo.tipoConteudo === TipoConteudo.LIBERACOES) {
      totalItens = loteOperacoes.liberacoesParaOperacoes.reduce((acc, o) => {
        return acc + o.liberacoes.length;
      }, 0);
    } else {
      totalItens = loteOperacoes.amortizacoesAntecipadas.length;
    }
    marcador.marcaTempo("forEach-datas");

    const opcaoEnvioStr = this.loteOperacoesForm.get('opcaoEnvio').value;
    const apenasValidar = (opcaoEnvioStr === 'validar');

    const exibirMensagemSucesso = (res) => {
      this.loadingService.liberaTela();
      if (this.arquivo.tipoConteudo == TipoConteudo.OPERACOES) {
        const mensagemSucesso = `${res.mensagem} Id de protocolo: ${res.idProtocolo}`;
        msgService.addMessage({
          title: 'Sucesso',
          type: 'CRUD_OPERATION',
          level: messageLevel.SUCCESS,
          message: mensagemSucesso
        });
        this.router.navigate(['/operacoes/lote']);
      }
      else {
        this.operacoes = res;
        msgService.addMessage(this.gerarMensagemSucesso(this.arquivo.tipoConteudo, totalItens));
      }
      this.limpar();
    };

    const exibirMensagemErro = (err) => {
            this.loadingService.liberaTela();
      this.ocorrencias = this.service.ocorrencias;
      this.limpar();
    };

    if (this.arquivo.tipoConteudo === TipoConteudo.OPERACOES) {
      this.service.enviarOperacoes(loteOperacoes, apenasValidar).subscribe(exibirMensagemSucesso, exibirMensagemErro);
    } else if (this.arquivo.tipoConteudo === TipoConteudo.LIBERACOES) {
      this.service.enviarLiberacoes(loteOperacoes, apenasValidar).subscribe(exibirMensagemSucesso, exibirMensagemErro);
    } else {
      this.protocoloService.enviarArquivo(this.arquivo, this.arquivo.tipoConteudo, apenasValidar)
        .pipe(
            map(res => {
                const loteOperacoes = JSON.parse(res.mensagem);
                return loteOperacoes.operacoes;
            }),
        ).subscribe(exibirMensagemSucesso, exibirMensagemErro);
    }
  }

  private gerarMensagemSucesso(tipoConteudo: TipoConteudo, totalItens) {

    let msgSucesso: string;

    const descricaoConteudo = LabelTipoConteudo.get(tipoConteudo);

    if (this.loteOperacoesForm.get('opcaoEnvio').value === 'validar') {
      msgSucesso = `Todas as ${descricaoConteudo} são enquadráveis ao FGI PEAC neste instante.`;
    } else {
      msgSucesso = `Todas as ${descricaoConteudo} foram enviadas com sucesso.`;
    }

    msgSucesso += ` Total de ${descricaoConteudo}: ${totalItens}`;

    return {
      title: 'Sucesso',
      type: 'CRUD_OPERATION',
      level: messageLevel.SUCCESS,
      message: msgSucesso
    };
  }

  private validarArquivo(nomeArquivo, tipoArquivo, conteudoArquivo): Lote {
    if (tipoArquivo !== 'application/json') {
      this.bnAlertsService.alertaErro('Erro', `O sistema suporta apenas arquivos JSON - '${nomeArquivo}' --> '${tipoArquivo}'.`);
      this.limpar();
      return null;
    }

    if (conteudoArquivo === null || conteudoArquivo === '') {
      this.bnAlertsService.alertaErro('Erro', 'O arquivo está vazio.');
      this.limpar();
      return null;
    }

    if (!Utils.isValidJson(conteudoArquivo)) {
      this.bnAlertsService.alertaErro('Erro', 'Não foi possível validar o arquivo JSON. ' +
        'Verifique se há erros de sintaxe no arquivo, como vírgulas mal colocadas ou chaves não fechadas. ' +
        'Uma sugestão é utilizar um dos vários sites de validação JSON disponíveis na web.');
      this.limpar();
      return null;
    }

    const conteudo = JSON.parse(conteudoArquivo);

    const lote = FabricaLote.criar(conteudo);

    if (lote === null) {
      this.bnAlertsService.alertaErro('Erro', 'O arquivo não contém novas operações, liberações ou amortizações.');
      this.limpar();
      return null;
    }


    const erro = lote.validar();
    if (erro !== null) {
        this.bnAlertsService.alertaErro('Erro', erro);
        this.limpar();
        return null;
    }

    return lote;
  }

  canDeactivate(): Observable<boolean> | boolean {
    console.log(this.enviado);

    if (this.enviado || this.loteOperacoesForm.pristine) {
      return true;
    } else {
      // map necessario porque bnConfirm retorna string e nao boolean
      return this.verificaSePodeSair().pipe(map(res => res === 'ok'));
    }
  }

  verificaSePodeSair(): Observable<string> {
    this.bnConfirm.abrirModal();
    return this.bnConfirm.resultadoConfirm.asObservable();
  }

  baixarTabelaDeErros() {
    const ocorrenciasJson = JSON.stringify(this.ocorrencias);
    this.fileUtils.exportarArquivo('erros.json', ocorrenciasJson, FileUtilsService.APPLICATION_JSON);
  }

  baixarTabelaDeOperacoes() {
    const operacoesJson = JSON.stringify(this.operacoes, this.ajustaDatas());
    this.fileUtils.exportarArquivo('operacoes.json', operacoesJson, FileUtilsService.APPLICATION_JSON);
  }

  ajustaDatas(): (key: any, obj: any) => any {
    let dateTimeFields:any = {};
    dateTimeFields.dataEnvio = "DateTime";
    dateTimeFields.dataReferenciaProtocolo = "Date";
    dateTimeFields.dataContratacao = "Date";
    dateTimeFields.dataReferenciaReceitaBruta = "Date";
    dateTimeFields.dataPrimeiraLiberacao = "Date";
    dateTimeFields.data = "Date";

    return ((key, obj) => {
      if (!dateTimeFields[key]) {
        return obj;
      }

      if (dateTimeFields[key] === "Date") {
        return moment(obj).format("YYYY-MM-DD");
      }

      if (dateTimeFields[key] === "DateTime") {
        return moment(obj).format("YYYY-MM-DDTHH:mm:ss.SSS");
      }

      // Não deve ter sobrado nada para cá
      return obj;
    })
  }

  tiposConteudo() {
    return TipoConteudo;
  }

  limpar() {
    this.arquivo = null;

    this.loteOperacoesForm.reset();
    this.loteOperacoesForm.markAsPristine();
    this.loteOperacoesForm.enable();
    this.loteOperacoesForm.updateValueAndValidity();

    this.enviado = false;
  }

  voltar() {
    this.router.navigate(['/operacoes/pesquisa']);
  }

  private suportaTamArquivo(fileSizeBytes: number): boolean {
    // tenta descobrir o quanto temos de memória
    let memSizeBytes = undefined;
    let perf: any = window.performance;
    if (perf.memory) {
      memSizeBytes = perf.memory.jsHeapSizeLimit;
    }

    if (memSizeBytes) {
      const limiteBytes = Math.round(memSizeBytes / 30); // Número mágico, apurado com algumas medições
      console.log(`limiteArquivo - estimado pela memória livre. fileSizeBytes: ${fileSizeBytes} limiteBytes: ${limiteBytes}`);
      return fileSizeBytes < limiteBytes;
    } else {
      const limiteBytes = 64 * 1024 * 1024; // 64 MB deve caber em uma máquina com 8GB
      console.log(`limiteArquivo - valor fixo. fileSizeBytes: ${fileSizeBytes} limiteBytes: ${limiteBytes}`);
      return fileSizeBytes < limiteBytes;
    }
  }
}

class MarcadorTempo {
  private timestamp = Date.now();

  constructor(private nome:string) {}

  public inicia(): void {
    this.timestamp = Date.now();
  }

  public marcaTempo(msg: string): void {
    console.log(`[${this.nome}] ${msg} -`, (Date.now() - this.timestamp));
    this.inicia();
  }
}

abstract class Lote {
  conteudo: any;

  constructor(public tipoConteudo: TipoConteudo, conteudo: any) {
    this.conteudo = conteudo;
  };

  abstract validar();
}

class LoteOperacoes extends Lote {
  constructor(conteudo: any) {
    super(TipoConteudo.OPERACOES, conteudo);
  };

  validar() {
    const operacoesSemId = this.conteudo.operacoes.filter(ope => ope.idOperacaoAgente == null);
    if (operacoesSemId.length > 0) {
      return 'Existe operação sem o atributo \'idOperacaoAgente\' no arquivo.';
    }

    return null;
  }
}

class LoteLiberacoes extends Lote {
  constructor(conteudo: any) {
    super(TipoConteudo.LIBERACOES, conteudo);
  };

  validar() {
    return null;
  }
}

class LoteAmortizacoes extends Lote {
  constructor(conteudo: any) {
    super(TipoConteudo.AMORTIZACOES_ANTECIPADAS, conteudo);
  };

  validar() {
    return null;
  }
}

class FabricaLote {
  static criar(conteudo: any): Lote {
    if(conteudo.operacoes) {
      return new LoteOperacoes(conteudo);
    } else if (conteudo.codigoTipoOperacao) {
      return null;
    } else if(conteudo.liberacoesParaOperacoes) {
      return new LoteLiberacoes(conteudo);
    } else if(conteudo.amortizacoesAntecipadas) {
      return new LoteAmortizacoes(conteudo);
    } else {
      return null;
    }
  }
}
